import '@gjensidige/core-global-css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { clientIdentification } from '@gjensidige/service-client-identification';
import { remoteLogWindowOnError } from '@gjensidige/service-error-handler';

import packageJson from '../package.json';
import App from './app/App';

window.onerror = (msg, ...rest) =>
  remoteLogWindowOnError(
    typeof msg === 'string' ? msg : msg.toString(),
    ...rest
  );

clientIdentification.configure({
  clientId: 'se-open-page-call-me',
  clientVersion: packageJson?.version || ''
});

ReactDOM.createRoot(document.getElementById('call-me-se')!).render(<App />);
